<template>
  <div>
    <span :id="labelId" class="sf-input__label !tw-text-sf-gray-dark">
      {{ label }}
    </span>
    <SfDropdown
      :dropdown-id="`${labelId}-dropdown`"
      :aria-labelledby="labelId"
      is-full-width
    >
      <template #trigger>
        <span v-if="selectedLabel">{{ selectedLabel }}</span>
        <span v-else class="tw-text-sf-gray-lighter">{{ placeholder }}</span>
      </template>
      <template #menu>
        <SfDropdownItem
          v-for="option in options"
          :key="String(option.value)"
          :has-checkmark="option.value === model"
          @click="select(option.value)"
        >
          {{ option.label || placeholder }}
        </SfDropdownItem>
      </template>
    </SfDropdown>
  </div>
</template>

<script setup lang="ts" generic="V extends string | number | null">
import { computed, useId } from 'vue'

import SfDropdown from '@app/shared/vue/connected/sf-dropdown.vue'
import SfDropdownItem from '@app/shared/vue/components/sf-dropdown/sf-dropdown-item.vue'
import useI18n from '@app/shared/vue/composables/use-I18n'
import { useDropdown } from '@app/shared/pinia/dropdown'
import getPiniaInstance from '@app/shared/pinia/instance'

defineOptions({ name: 'PanelDropdown' })

const props =
  defineProps<{
    label: string
    options: { value: V; label: string }[]
  }>()

const model = defineModel<V | undefined>()

const I18n = useI18n()
const labelId = useId()
const dropdownStore = useDropdown(getPiniaInstance())
const placeholder = I18n.t('common.select')

const selectedLabel = computed(
  () => props.options.find((option) => option.value === model.value)?.label
)

// SfDropdownItem stops its click, so the dropdown never sees it and stays open.
function select(value: V): void {
  model.value = value
  dropdownStore.closeDropdown()
}
</script>
